import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppTitleService } from '../../../services/app-title.service';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HttpErrorResponse } from '@angular/common/http';
import { ParticipanteService } from '../../../services/participante.service';
import { ToastService, ScnackbarData, SnackbarStyles } from '../../../commons/toast.service';
import { AdministrationService } from '../../../services/administration.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DlgListaEnvioComponent } from './dlg-lista-envio/dlg-lista-envio.component';

@Component({
  selector: 'app-lista-envio',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatIconModule, MatButtonModule, MatTooltipModule, MatToolbarModule, MatDialogModule],
  templateUrl: './lista-envio.component.html',
  styleUrls: ['./lista-envio.component.scss']
})
export class ListaEnvioComponent implements OnInit {
  displayedColumns: string[] = ['titulo', 'acciones'];
  dataSource = new MatTableDataSource<any>([]);

  private participanteServ: ParticipanteService = inject(ParticipanteService);
  private toast: ToastService = inject(ToastService);
  private dialog: MatDialog = inject(MatDialog);
  private adminServ: AdministrationService = inject(AdministrationService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    const appTitle = inject(AppTitleService) as AppTitleService;
    appTitle.setTitle('Lista de env\xedos');
  }

  ngOnInit(): void {
    this.loadListasEnvio();
  }

  private extractId(item: any): any {
    if (!item) return undefined;
    return item.id ?? item.codigo ?? item.codigoLista ?? item.codigo_participante ?? item.codigoParticipante ?? item.listaId ?? item._id;
  }

  private extractName(obj: any): string {
    if (!obj) return '';
    return (obj.nombre || obj.name || obj.titulo || obj.nombreLista || obj.tituloLista || obj.descripcion || obj.nombre?.toString() || '').toString();
  }

  loadListasEnvio() {
    this.participanteServ.getListasEnvio().subscribe({
      next: (res: any[]) => {
        this.dataSource = new MatTableDataSource<any>(res || []);
        try { this.cdr.detectChanges(); } catch (e) { }
      },
      error: (err: HttpErrorResponse) => {
        this.dataSource = new MatTableDataSource<any>([]);
        try { this.cdr.detectChanges(); } catch (e) { }
        if (err?.status === 404 || err?.status === 204) {
          return;
        }
        const data = { message: 'Error cargando listas', style: SnackbarStyles.Error } as ScnackbarData;
        this.toast.show(data);
      }
    });
  }

  onEdit(item: any) {
    const id = this.extractId(item);
    const nombre = item?.nombre || item?.titulo || item?.tituloLista || item?.descripcion || item?.nombreLista || item?.name || '';
    const dialogRef = this.dialog.open(DlgListaEnvioComponent, {
      width: '720px',
      data: { id, nombre }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const data: ScnackbarData = { message: `Lista actualizada: ${this.extractName(result) || ''}`, style: SnackbarStyles.Success } as ScnackbarData;
        this.toast.show(data);
        this.loadListasEnvio();
      }
    });
  }

  onDelete(item: any) {
    const id = this.extractId(item);
    if (!item || id == null) return;
    const confirmed = confirm('¿Eliminar la lista "' + (item.nombre || item.titulo || item.nombreLista || '') + '"?');
    if (!confirmed) return;
    this.participanteServ.deleteListaEnvio(Number(id)).subscribe({
      next: () => {
        const data: ScnackbarData = { message: `Lista eliminada`, style: SnackbarStyles.Success } as ScnackbarData;
        this.toast.show(data);
        this.loadListasEnvio();
      },
      error: (err: any) => {
        const data: ScnackbarData = { message: 'Error eliminando lista', style: SnackbarStyles.Error } as ScnackbarData;
        this.toast.show(data);
      }
    });

  }

  onNew() {
    const dialogRef = this.dialog.open(DlgListaEnvioComponent, {
      width: '720px',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const data: ScnackbarData = { message: `Lista creada: ${this.extractName(result) || ''}`, style: SnackbarStyles.Success };
        this.toast.show(data);
        this.loadListasEnvio();
      }
    });
  }
}
